import React 		from 'react';
import PropTypes 	from 'prop-types';

//this.props.classes			: string of classes
//this.props.items				: array of items {id, name}

export default class DropdownInput extends React.Component 
{
	constructor(props) {
		super(props);

		this.state = {
			showInput: props.inputID === null ? true : false,
		}
	}

	componentDidUpdate(prevProps, prevState) 
	{
		if ( prevState.showInput != this.state.showInput ) 
		{
			this.input.focus();
		}
	}

	render() 
	{
		const {classes = ''} = this.props;

		return (
			<div className={"dropdown-input " + classes}>
				{this.state.showInput ? this.renderInput() : null}
				{this.renderSelect()}
			</div>
		);
	}

	renderSelect() 
	{
		const items 		= this.props.items;
		const options 		= items.map((item, key) => <option key={key} value={item.id}>{item.name}</option>);
		const customValue 	= this.props.customValue || 'Create new list';

		return (
			<select className={"dropdown-input__select" + (this.state.showInput ? " dropdown-input__select--minified" : "")} value={Number.isInteger(this.props.inputID) ? this.props.inputID : "_$new$_"} onChange={(e) => this.handleDropdownChange(e)}>
				{options}
				<option value='_$new$_'>{customValue}</option>
			</select>
		);
	}

	renderInput() 
	{
		return (
			<div className="dropdown-input__input">
				<input className="dropdown-input__input-input" type="text" placeholder={this.props.inputPlaceholder} value={this.props.inputValue} onChange={(e) => this.props.inputValChange(e.target.value)} ref={input => this.input = input}/>
				{this.props.inputValue ? <button className="dropdown-input__input-clear" onClick={() => this.props.inputValChange('')}><i className="fas fa-times-circle"></i></button> : null}
			</div>
		);
	}

	handleDropdownChange( e ) 
	{
		if ( e.target.value == '_$new$_' ) 
		{
			this.setState({showInput: true});
			this.props.inputIDChange( null );
		}
		else
		{
			this.setState({showInput: false});
			this.props.inputIDChange( parseInt(e.target.value) );
		}
	}
}

DropdownInput.propTypes = {
		classes: PropTypes.string
	,	items: PropTypes.arrayOf(PropTypes.shape({
				id: PropTypes.oneOfType([
					PropTypes.string,
					PropTypes.number
				  ]).isRequired
			,	name: PropTypes.string.isRequired
		})).isRequired
	,	inputValue: PropTypes.string
	,	inputID:	PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number
	  	])
	, inputPlaceholder: PropTypes.string
	, inputIDChange: PropTypes.func.isRequired
	, inputValChange: PropTypes.func.isRequired
	, customValue: PropTypes.string
}